import React from "react";
import logo from '../assets/jrlogo.png'; // Make sure this path is correct
import AdminLink from './AdminLink';
import { Link } from 'react-router-dom';

const Header = ({ user }) => {
  return (
    <div className="bg-green-50 border-b border-green-100 p-4 flex items-center justify-between shadow-sm">
      <div className="flex items-center w-full">
        <img src={logo} alt="JR Logo" className="w-10 h-10 rounded-full" />
        <h1 className="text-lg sm:text-xl font-bold text-green-700 ml-2">JR Home Foods</h1>
        {/* Desktop navigation links */}
        <nav className="hidden md:flex items-center space-x-6 ml-auto pl-16">
          <Link to="/" className="text-green-700 hover:text-green-900 font-medium">Home</Link>
          <Link to="/myplan" className="text-green-700 hover:text-green-900 font-medium">My Plan</Link>
          <Link to="/profile" className="text-green-700 hover:text-green-900 font-medium">Profile</Link>
          <Link to="/settings" className="text-green-700 hover:text-green-900 font-medium mr-6">Settings</Link>
        </nav>
      </div>
      <div className="flex items-center space-x-4">
        <AdminLink />
        {/* You can add other elements here, like a cart icon or user profile */}
        {user && (
          <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center text-white font-bold">
            {user.displayName?.charAt(0).toUpperCase() || 'U'}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header; 